/** 기타/자유전공학부 이수요건 — 데이터 미입력 */
export const ETC_REQUIREMENTS = []
